// extracted by mini-css-extract-plugin
export var cardLayout = "_6l-1";
export var paginationContainer = "_6l-0";